import { use } from 'react';
import TailwindContext from '../tailwind.context';
const useColors = () => {
    const { config } = use(TailwindContext);
    return config.theme?.colors;
};
export default useColors;
